<div class="detail" *ngIf="now < stopDate && now >= startDate">
  <div class="part">
    <img src="../../../../../../assets/images/holiday/zhuyi.png" alt="" />
    <span>故障时长保障须知：</span>
  </div>
  <div class="part">
    <span>
      请务必提供详细说明及相关截图。我们将以提交时间点为您锁定到期时长。待春节假期（2月15日至
      2月22日）结束后，我们将通过系统日志严格核对，确认后统一补回时长。
    </span>
  </div>
</div>
